var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related_questions_user_text_container"},[_c('text-bubble',{attrs:{"payload":_vm.textBubblePayload}}),_c('div',{staticClass:"related_questions_user_text_title_container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$slots.default.payload.data.title)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }